import { useSelector } from 'react-redux';
import {
  approvalWorkflowsFeatureSelector,
  labelsFeatureSelector,
} from '../../../features/pricing/selectors';
import { useQueues } from '../../../features/queues/hooks/useQueues';
import { useReportingFlags } from '../../../features/reporting/core/hooks';
import {
  canUserApproveSelector,
  userRoleNameSelector,
} from '../../../redux/modules/user/selectors';
import { isTabVisible, tabs } from '../navigationStructure';

export const useVisibleTabs = () => {
  const workflowsEnabled = useSelector(approvalWorkflowsFeatureSelector);
  const isLabelsEnabled = useSelector(labelsFeatureSelector);
  const canUserApprove = useSelector(canUserApproveSelector);
  const userRole = useSelector(userRoleNameSelector);
  const { isReportingEnabled } = useReportingFlags();

  const {
    data: queues,
    isSuccess: areQueuesLoaded,
    isFetched,
  } = useQueues({
    fields: ['id'],
    pageSize: 1,
  });

  const approverHasNoQueues =
    userRole === 'approver' && areQueuesLoaded && !queues.results.length;

  const visibleTabs = tabs.filter(tab => {
    if (tab.name === 'requests') return workflowsEnabled && canUserApprove;
    if (tab.name === 'documents') return !approverHasNoQueues;
    if (tab.name === 'reports') return isReportingEnabled;
    if (tab.name === 'settings' && userRole === 'empowered_manager')
      return isLabelsEnabled;

    return isTabVisible(tab, userRole);
  });

  return isFetched && userRole ? visibleTabs : [];
};
